import { graphql } from "@opensea/graphql"
import { itemQuantitiesForQuoteFragment } from "../../../../utils/itemQuantitiesForQuote.fragment"

export const CheckoutTimeline_quoteFragment = graphql(
  `
    fragment CheckoutTimeline_quote on Quote {
      supportsRelayerFulfillment {
        crossChain
      }
      totalPrice {
        pricePerToken {
          usd
          token {
            contractAddress
            chain {
              identifier
            }
            symbol
          }
        }
      }
      ...itemQuantitiesForQuote
    }
  `,
  [itemQuantitiesForQuoteFragment],
)
